module.exports = __webpack_public_path__ + "static/media/perro-azul.19d10563.svg";